import { render, staticRenderFns } from "./SolutionCrm.vue?vue&type=template&id=3451f078"
import script from "./SolutionCrm.vue?vue&type=script&lang=js"
export * from "./SolutionCrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports